import { IRateCard } from "@wingspanhq/payments/dist/interfaces";
import { IRateCardCreateRequest } from "@wingspanhq/payments/dist/interfaces/api";
import { servicePayments } from "../servicePayments";

export const createRateCard = async (
  request: IRateCardCreateRequest
): Promise<IRateCard> => {
  const response = await servicePayments.post("/rate-card", request);
  return response.data;
};
